import React, { useEffect } from 'react';

import NotFoundPage from 'web/components/NotFoundPageComponent';

const NotFoundMobile = props => {
  useEffect(() => {
    goRedirect();
  });

  const goRedirect = () => {
    let tmp = '';
    let pathTmp = [];
    const { history } = props;
    tmp = window.location.pathname;
    pathTmp = tmp.split('/');
    if (pathTmp[1] === 'event') {
      return history.push('/');
    }
  };

  return <NotFoundPage type={'mobile'} />;
};

export default NotFoundMobile;
